export const affiliatedLevelsData = [
  { value: 0, label: "Todos Afiliados" },
  { value: 1, label: "Afiliados Nv. 1" },
  { value: 2, label: "Afiliados Nv. 2" },
  { value: 3, label: "Afiliados Nv. 3" },
];
